import { TableCell, TableRow } from "@material-ui/core";

import ExtensionIcon from "@material-ui/icons/Extension";
import { useStyle } from "../../../../context/StyleContext";

export default function BotonPerfil(props) {
    const { boton } = props;
    const colorClass = "color-3";

    const { classes } = useStyle();

    return (
        <TableRow>
            <TableCell classes={{ sizeSmall: classes.cellButton }} align="left">
                <ExtensionIcon className={colorClass + " vertical-align-middle"} />
                <span className={colorClass + " size-15"}>
                    {boton.sNombre} ({boton.iIdBoton})
                </span>
            </TableCell>
        </TableRow>
    );
}
